module.exports = __webpack_public_path__ + "img/usn.fbf0726b.jpg";